import React, { Component } from "react";
import styles from "./tripUnitsBar.module.scss";
import SideBar from "../../sides/sideBar";
import CarsTitleClosedBar from "../../sections/cars/carsTitleClosedBar";
import SideBarInner from "../../../shared/sideBarInner";
import CarsSortPanel from "../../sections/cars/carsSortPanel";
import CarsPaginationSettingsPanel from "../../sections/cars/carsPaginationSettingsPanel";
import CarsSecondSideBar from "../../sections/secondSideBars/carsSecondSideBar";
import CarsTitleBar from "../../sections/cars/carsTitleBar";
import { withUnits } from "../../../shared/containers/containerUnits";
import { withCars } from "../../../shared/containers/containerCars";
import TripUnitListWrapper from "./TripUnitListWrapper";

class TripUnitsBar extends Component {
  constructor(props) {
    super(props);

    this.state = { isCheck: false, toAction: [], actionDelete: false };
  }

  componentDidUpdate(preProps) {}

  onClickHandler() {}

  render() {
    return (
      <div className={styles.sideBarsWrapper}>
        <SideBar TitleClosed={<CarsTitleClosedBar />}>
          <div className={styles.userUnitsBar}>
            <SideBarInner>
              <CarsTitleBar />
            </SideBarInner>

            <SideBarInner>
              <CarsSortPanel />
            </SideBarInner>

            <SideBarInner>
              <div className={styles.inLineContainer}>
                <CarsPaginationSettingsPanel />
              </div>

              <div className={styles.container_userUnitsList}>
                <TripUnitListWrapper />
              </div>
            </SideBarInner>
          </div>
        </SideBar>

        <CarsSecondSideBar />
      </div>
    );
  }
}

export default withCars(withUnits(React.memo(TripUnitsBar)));
